import { connect } from 'react-redux';
import { getStudentBrandName } from '../../api/redux-watson/watson-config-selectors';
import BrandedDocumentTitle from '../core/common/BrandedDocumentTitle';

const mapStateToProps = state => ({
  brandName: getStudentBrandName(state),
});

export default connect(mapStateToProps)(BrandedDocumentTitle);
